export type ActiveWorkspace = "pfa" | "partner";

const STORAGE_KEY = "kryajet_active_workspace";

export function getActiveWorkspace(): ActiveWorkspace {
  if (typeof window === "undefined") return "pfa";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === "partner" ? "partner" : "pfa";
}

export function setActiveWorkspace(workspace: ActiveWorkspace): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, workspace);
}
